import { RootState } from '~/store';

export const getQrCodeReducerData = (state: RootState) => state.qrCodeReducer;
